import { USERACCESS } from '@Constants/LocalStorage'
import { set } from '@Core/LocalStorage'
import { clearAllCookies } from '@Core/Cookies'
import initialUserState from './initialUserState'

const getCurrentUserAgent = () => {
  if (typeof navigator === 'undefined') return ''
  return navigator.userAgent || ''
}

const resolveBoundIp = (payload = {}, previousIp = '') => {
  return (
    payload?.client_ip ||
    payload?.ip_address ||
    payload?.ip ||
    payload?.session_ip ||
    previousIp ||
    ''
  )
}

const cases = {
  SET_USER_ACCESS: (state, payload) => {
    const boundUserAgent = payload?.bound_user_agent || getCurrentUserAgent()
    const boundIp = resolveBoundIp(payload, state?.userAccess?.bound_ip)

    return {
      ...state,
      userAccess: {
        ...state.userAccess,
        ...payload,
        bound_user_agent: boundUserAgent,
        bound_ip: boundIp,
      },
    }
  },
  SET_USER_DATA: (state, payload) => {
    let isLogin = false
    if (payload?.id && !Boolean(payload?.isLoginFalse)) {
      isLogin = true
    }
    const tempUserData = {
      ...state,
      userAccess: {
        ...state.userAccess,
        isLogin: isLogin,
      },
      userData: {
        ...state.userData,
        ...payload,
      },
    }
    // set value into localstorage
    set(USERACCESS, JSON.stringify(tempUserData))
    return tempUserData
  },
  LOGOUT_USER_DATA: () => {
    const tempUserData = initialUserState

    // Full session invalidation: storage and client-accessible cookies
    set(USERACCESS, JSON.stringify(tempUserData))
    sessionStorage.clear()
    clearAllCookies()
    return tempUserData
  },
}

const reducer = (state, action) => {
  return cases[action.type](state, action.payload)
}

export default reducer
